export const name = 'adminController';
export default function quotaController($translate, privilegesService, templatesService, $log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  init();

  vm.quotaRefundErrorMsg = undefined;
  vm.numberOfProcessesErrorMsg = undefined;
  vm.numOfFastParallelThreads = undefined;
  vm.numOfRichParallelThreads = undefined;
  vm.numOfFastParallelThreadsSdk = undefined;
  vm.numOfRichParallelThreadsSdk = undefined;
  vm.refundHistory = null;



  vm.doRefund = function(){
    privilegesService.adminRefund(vm.refundQuota, vm.description).then(data => {
      if(data.refunds !== null) {
        vm.refundHistory = formatRefundDate(data.refunds);
        vm.refundSucceedMsg = 'Refund of ' + vm.refundQuota + ' records succeed';
        vm.quotaRefundErrorMsg = undefined;
      }
    }, error => {
      vm.quotaRefundErrorMsg = 'Failed to refund ' + vm.refundQuota;
      $log.log(angular.toJson({functionName:'refund', action:'failed to refund' + vm.refundQuota, error:error}));
    });
  };

  vm.setNumberOfParallelProcesses = function(){
    templatesService.updateNumberOfAllowedParallelThreads(vm.numOfFastParallelThreads, vm.numOfRichParallelThreads, vm.numOfFastParallelThreadsSdk, vm.numOfRichParallelThreadsSdk).then(
      success => {
        vm.isChangeParallelProcessesSuccess = true;
        vm.numberOfProcessesErrorMsg = undefined;
        if(success != null) {
          vm.numOfFastParallelThreads = success.numberOfAllowedFastParallelThreads;
          vm.numOfRichParallelThreads = success.numberOfAllowedRichParallelThreads;
          vm.numOfFastParallelThreadsSdk = success.numberOfAllowedFastParallelThreadsSdk;
          vm.numOfRichParallelThreadsSdk = success.numberOfAllowedRichParallelThreadsSdk;
        }else{
          vm.numberOfProcessesErrorMsg = "Failed to update number of parallel processes";
        }
      },
      error => {
        if(error === 401){
          vm.numberOfProcessesErrorMsg = "You are not allowed to change number of parallel processes";
        }else{
          vm.numberOfProcessesErrorMsg = "Failed to update number of parallel processes";
        }
        vm.isChangeParallelProcessesSuccess = false;
      }
    );
  };

  function init(){

    templatesService.getNumberOfAllowedParallelThreads().then(response => {
        if(response != null){
          vm.numOfFastParallelThreads = response.numberOfAllowedFastParallelThreads;
          vm.numOfRichParallelThreads = response.numberOfAllowedRichParallelThreads;
          vm.numOfFastParallelThreadsSdk = response.numberOfAllowedFastParallelThreadsSdk;
          vm.numOfRichParallelThreadsSdk = response.numberOfAllowedRichParallelThreadsSdk;
        }else{
          vm.numOfFastParallelThreads = 3;
          vm.numOfRichParallelThreads = 3;
          vm.numOfFastParallelThreadsSdk = 3;
          vm.numOfRichParallelThreadsSdk = 3;
        }

      },
      error => $log.log(angular.toJson({functionName:'getNumberOfParallelThreads', action:'failed to fetch parallel threads', error:error})));

    privilegesService.getAdminRefunds().then(data => {
      if(data.refunds !== null) {
        vm.refundHistory = formatRefundDate(data.refunds);
      }
    }, error => {
      $log.log(angular.toJson({functionName:'refund', action:'failed to fetch refund history', error:error}));
    });
  }

  function formatRefundDate(refundHistory){
    return refundHistory.map(curr => {
      curr.refundAt = new Date(curr.refundAt).toLocaleDateString("en-US");
      return curr;
    });
  }
}
